<template>
<div class="order-manage">
    <div class="top_handle_box">
        <div style="width: 25%;padding-right: 15px;box-sizing: border-box;margin-bottom: 10px;">
            <el-date-picker v-model="datetime" @change="handleDatetimeChange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="订单开始日期" end-placeholder="订单开始日期"></el-date-picker>
        </div>
        <div style="width: 25%;padding-right: 15px;box-sizing: border-box;margin-bottom: 10px;">
            <el-select v-model="subjectcode" placeholder="科目名称" clearable>
                <el-option v-for="item in subjectList" :key="item.subjectcode" :label="item.subjectname" :value="item.subjectcode"></el-option>
            </el-select>
        </div>
        <div style="width: 25%;padding-right: 15px;box-sizing: border-box;margin-bottom: 10px;">
            <el-select v-model="paytype" placeholder="付款类型" clearable>
                <el-option v-for="item in paytypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </div>
        <div style="width: 25%;padding-right: 15px;box-sizing: border-box;margin-bottom: 10px;">
            <el-select v-model="status" placeholder="订单状态" clearable>
                <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </div>
        <div style="width: 25%;padding-right: 15px;box-sizing: border-box;margin-bottom: 10px;">
            <el-input v-model="orderno" placeholder="订单号" clearable></el-input>
        </div>
        <div style="width: 25%;padding-right: 15px;box-sizing: border-box;margin-bottom: 10px;">
            <el-input v-model="customername" placeholder="用户姓名" clearable></el-input>
        </div>
        <div style="width: 25%;padding-right: 15px;box-sizing: border-box;margin-bottom: 10px;">
            <el-input v-model="mobileno" placeholder="手机号码" clearable></el-input>
        </div>
        <div style="width: 25%;text-align: right;padding-right: 15px;box-sizing: border-box;margin-bottom: 10px;">
            <el-button @click="handleReset">重置</el-button>
            <el-button @click="handleSearch" type="primary" plain>搜索</el-button>
        </div>
    </div>
    <div class="btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="序号" width="80px" align="center" fixed>
                <template slot-scope="scope">{{(page - 1) * pagesize + scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column label="订单号" min-width="180px" fixed>
                <template slot-scope="scope">
                    <div class="orderno" @click="handleOpenOrderDetails(scope.row)">{{scope.row.orderno}}</div>
                </template>
            </el-table-column>
            <el-table-column label="用户名称" min-width="150px">
                <template slot-scope="scope">
                    <div>{{scope.row.customername}}({{scope.row.customerinnerid}})</div>
                    <div>{{scope.row.mobileno ? scope.row.mobileno : '--'}}</div>
                </template>
            </el-table-column>
            <el-table-column label="订单来源" width="100px" align="center">
                <template slot-scope="scope">{{scope.row.ordersourcename}}</template>
            </el-table-column>
            <el-table-column label="产品名称" min-width="120px" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.productname}}</template>
            </el-table-column>
            <el-table-column label="科目名称" min-width="150px" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.subjectnames}}</template>
            </el-table-column>
            <el-table-column label="付款方式" width="100px" align="center">
                <template slot-scope="scope">{{scope.row.paytypename}}</template>
            </el-table-column>
            <el-table-column label="支付金额" width="130px" align="center">
                <template slot-scope="scope">{{scope.row.finalpaymoney ? (scope.row.finalpaymoney + '元') : '--'}}</template>
            </el-table-column>
            <el-table-column label="订单状态" width="100px" align="center">
                <template slot-scope="scope">
                    <div :class="['status' + scope.row.orderstatus]">{{scope.row.orderstatusname}}</div>
                </template>
            </el-table-column>
            <el-table-column label="订单时间" width="150px" align="center">
                <template slot-scope="scope">{{scope.row.orderdatetime}}</template>
            </el-table-column>
            <el-table-column label="操作" width="100px" align="right">
                <template slot-scope="scope">
                    <div class="tr" v-if="scope.row.orderstatus === 9">
                        <span class="separator-btn">
                            <el-button @click.stop="handleUpdateTopicQuestionbankOrderStatus(scope.row, 30)" type="text" size="small">完成</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click.stop="handleUpdateTopicQuestionbankOrderStatus(scope.row, 100)" type="text" size="small">无效</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background layout="sizes, prev, pager, next" :total="total" :page-size="pagesize" :current-page="page" @size-change="handlePagesizeChange" @current-change="handlePageChange" :page-sizes="[10, 20, 50, 100]"></el-pagination>
    </div>
    <OrderDetailsDialog ref="orderDetailsDialog"></OrderDetailsDialog>
    <AccomplishOrder ref="accomplishOrder" @handleAccomplishOrderSuccess="handleAccomplishOrderSuccess"></AccomplishOrder>
</div>
</template>
<script>
import {getTopicQuestionbankOrderList, updateTopicQuestionbankOrderStatus} from '@/api/questionApi.js'
import {mapActions} from 'vuex'
import OrderDetailsDialog from './orderDetailsDialog.vue'
import AccomplishOrder from './accomplishOrder.vue'
import SpecialBank from '@/common/js/specialBank.json'
export default {
    data() {
        return {
            init: false,
            page: 1,
            pagesize: 10,
            total: 0,
            tableData: [],
            customername: '', // 用户姓名
            datetime: [], // 订单日期
            datetimeend: '', // 订单日期 结束
            datetimestart: '', // 订单日期 开始
            mobileno: '', // 手机号码
            orderno: '', // 订单号码
            paytype: '', // 付款类型 1 支付宝支付 2 微信支付
            status: '', // 订单状态 9 待支付 30 已完成 100 已取消
            subjectcode: '', // 科目code
            paytypeList: [
                {label: '支付宝', value: 1},
                {label: '微信', value: 2}
            ],
            statusList: [
                {label: '待支付', value: 9},
                {label: '已完成', value: 30},
                {label: '已取消', value: 100},
            ],
            subjectList: [],
            condition: {
                customerinnerid: '',
                customername: '',
                datetimeend: '',
                datetimestart: '',
                examcode: '',
                mobileno: '',
                orderno: '',
                ordertype: '',
                paytype: '',
                status: '',
                subjectcode: ''
            }
        }
    },
    created() {
        if (this.$route.query.examcode) {
            this.subjectList = JSON.parse(JSON.stringify(SpecialBank[this.$route.query.examcode].children))
        }
    },
    methods: {
        initData(params) {
            if (!this.init) {
                this.condition.examcode = params.examcode
                this.handleGetTopicQuestionbankOrderList()
            }
        },
        handleDatetimeChange(date) {
            if (date && date[0] && date[1]) {
                this.datetimestart = date[0]
                this.datetimeend = date[1]
            } else {
                this.datetimestart = ''
                this.datetimeend = ''
            }
        },
        handleGetTopicQuestionbankOrderList() {
            this.setLoading(true)
            let params = {
                condition: JSON.parse(JSON.stringify(this.condition)),
                page: this.page,
                pagesize: this.pagesize
            }
            getTopicQuestionbankOrderList({
                data: params,
                success: data => {
                    this.setLoading(false)
                    this.total = data.pageableData.rowCount
                    this.tableData = data.data
                    this.init = true
                },
                error: error => {
                    this.setLoading(false)
                    this.$message.error(error.msg)
                }
            })
        },
        handleReset() {
            this.datetime = []
            this.datetimeend = ''
            this.datetimestart = ''
            this.mobileno = ''
            this.orderno = ''
            this.paytype = ''
            this.status = ''
            this.subjectcode = ''
            this.customername = ''
            this.handleSearch()
        },
        handleSearch() {
            this.page = 1
            this.condition.customername = this.customername
            this.condition.datetimeend = this.datetimeend
            this.condition.datetimestart = this.datetimestart
            this.condition.mobileno = this.mobileno
            this.condition.orderno = this.orderno
            this.condition.paytype = this.paytype
            this.condition.status = this.status
            this.condition.subjectcode = this.subjectcode
            this.handleGetTopicQuestionbankOrderList()
        },
        handlePagesizeChange(pagesize) {
            this.pagesize = pagesize
            this.page = 1
            this.handleGetTopicQuestionbankOrderList()
        },
        handlePageChange(page) {
            this.page = page
            this.handleGetTopicQuestionbankOrderList()
        },
        handleOpenOrderDetails(row) {
            this.$refs.orderDetailsDialog.handleOpen(row)
        },
        handleUpdateTopicQuestionbankOrderStatus(row, status) {
            if (status === 30) {
                this.$refs.accomplishOrder.handleOpen(row)
            } else if (status === 100) {
                this.$confirm('确认设置该订单无效吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.setLoading(true)
                    console.log(555)
                    updateTopicQuestionbankOrderStatus({
                        data: {
                            apptype: 0,
                            code: row.orderno,
                            status: 100
                        },
                        success: data => {
                            this.setLoading(false)
                            this.$message.success('操作成功！')
                            row.orderstatus = 100
                            row.orderstatusname = '已取消'
                        },
                        error: error => {
                            this.setLoading(false)
                            this.$message.error(error.msg)
                        }
                    })
                }).catch(() => {       
                })
            }
        },
        handleAccomplishOrderSuccess(data) {
            let index = ''
            this.tableData.some((item, i) => {
                if (item.orderno === data.orderno) {
                    index = i
                    return true
                }
            })
            if (index !== '') {
                let item = JSON.parse(JSON.stringify(this.tableData[index]))
                item.orderstatus = 30
                item.orderstatusname = '支付成功'
                if (data.paytype === 1) {
                    item.paytype = 1
                    item.paytypename = '支付宝'
                } else if (data.paytype === 2) {
                    item.paytype = 2
                    item.paytypename = '微信'
                }
                this.$set(this.tableData, index, item)
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        OrderDetailsDialog,
        AccomplishOrder
    }
}
</script>
<style lang="scss">
.order-manage {
    .top_handle_box {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;
        .el-date-editor {
            width: 100%;
            .el-input__icon, .el-range-separator {
                line-height: 25px;
            }
        }
        .el-select {
            width: 100%;
            .el-input {
                .el-input__suffix {
                    .el-input__icon {
                        line-height: 32px;
                    }
                }
            }
        }
    }
    .el-table {
        .orderno {
            color: #409EFF;
            cursor: pointer;
        }
        .status9 {
            color: #F56C6C;
        }
        .status30 {
            color: #67C23A;
        }
        .status100 {
            color: #909399;
        }
    }
    .el-pagination {
        text-align: right;
        .el-pagination__sizes {
            .el-select {
                height: 28px;
                .el-input {
                    height: 28px;
                    .el-input__inner {
                        height: 28px;
                    }
                }
            }
        }
    }
}
</style>